var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isRefuge)?_c('RefugeProfile'):(_vm.isAdoptant || _vm.isVolunteer)?_c('PersonProfile'):_c('div',[_vm._v("¡Algo salió mal!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }